import { orchestrator } from 'satcheljs';
import { default as completeGetStartedTask } from '../actions/completeGetStartedTask';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { completePhoneApp } from '../actions/completePhoneApp';

orchestrator(completePhoneApp, () => {
    completeGetStartedTask(GetStartedTaskId.DownloadMobile);
});
